import React from 'react';
import styled, { css } from 'styled-components';
import { Classable, HasChildren, Shapeable } from '@shapeable/types';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { Page } from '@shapeable/gesda-types';
import { ComponentPropsProvider, EntityCarousel } from '@shapeable/ui';
const cls = classNames('explorer-home-banner-layout');

// -------- Types -------->

// -------- Props -------->

export type ExplorerHomeBannerLayoutProps = Classable & HasChildren & { 
  entity?: Page;
};

export const ExplorerHomeBannerLayoutDefaultProps: Omit<ExplorerHomeBannerLayoutProps, 'entity'> = {
};

// -------- Child Component Props -------->

type ContainerProps = {

};

// -------- Styles -------->

const bannerTitleTextShadow = css`
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.18);
`;

const ContainerStyles = breakpoints({
  base: css`
  
  `,
});

const CarouselStyles = breakpoints({
  base: css`
    font-family: 'Aspekta', sans-serif;
    overflow: hidden;
    .shp--image-entity-background,
    .shp--image-entity-background-slideshow {
      overflow: visible;
    };

    .shp--entity-banner__titles {
      width: 100%;
    }

    .shp--cell-label {
      ${bannerTitleTextShadow};
      text-transform: none;
    }

    .shp--entity-banner__title {
      font-size: 2em;
      ${bannerTitleTextShadow};

    }
  `,
  landscape: css`
    .shp--entity-banner__titles {
      width: 90%;
    }
  `,
  tablet: css`
    .shp--entity-banner__title {
      font-size: 1.7em;
    }
  `,
  desktopDevice: css`
    border-radius: 0 0 ${theme.UNIT(3)} ${theme.UNIT(3)};
  `,
});

// -------- Components -------->

const My = {
  Container: styled.div<ContainerProps>`${ContainerStyles}`,
  Carousel: styled(EntityCarousel)`${CarouselStyles}`,
};

export const ExplorerHomeBannerLayout: Shapeable.FC<ExplorerHomeBannerLayoutProps> = (props) => {
  const { className, children, entity } = props;
  const { bannerLinks = [] } = entity;

  return (
    <ComponentPropsProvider value={{ 
      EntityBanner: {
        showOverlay: true,
        variant: 'image',
        useLinks: true,
        useBackgroundColor: true,
        customAspectRatio: { base: 4 / 3, landscape: 21 / 9, tablet: 21 / 9 },
      }}}>
    <My.Container className={className}>
      <My.Carousel
        items={bannerLinks}
        transitionType='fade'
        slideControls={{ variant: 'line', showNavigationButtons: true }}
      />
    </My.Container>
    </ComponentPropsProvider>
  )
};

ExplorerHomeBannerLayout.defaultProps = ExplorerHomeBannerLayoutDefaultProps;
ExplorerHomeBannerLayout.cls = cls;